module.exports = __webpack_public_path__ + "static/img/11_4Archive_12_Kaprow_HowtoUseVideotapes_1981_FPO_2.24b7b65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_12_Kaprow_HowtoUseVideotapes_1981_FPO_2.jpg
// module id = 1m2m
// module chunks = 0